import React, { useEffect, useState } from 'react';
import { initializeApp } from "firebase/app";
import {getDatabase, ref, push} from 'firebase/database'

const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_APIKEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTHDOMAIN,
    databaseURL: process.env.REACT_APP_FIREBASE_DATABASEURL,
    projectId: process.env.REACT_APP_FIREBASE_PROJECTID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGEBUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGINGSENDERID,
    appId: process.env.REACT_APP_FIREBASE_APPID,
    measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENTID
  };

const firebaseApp = initializeApp(firebaseConfig);
const database = getDatabase(firebaseApp);

const Analytics = () => {
  const [userData, setUserData] = useState(null);

  useEffect(() => {
    // Function to fetch user data
    const fetchUserData = async () => {
      try {
        // Get user IP address
        const ipAddressResponse = await fetch('https://api.ipify.org?format=json');
        const ipAddressData = await ipAddressResponse.json();
        const ipAddress = ipAddressData.ip;

        // Get user location based on IP address
        const locationResponse = await fetch(`https://ipapi.co/${ipAddress}/json/`);
        const locationData = await locationResponse.json();

        // Get user agent
        const userAgent = navigator.userAgent;

        // Get referrer
        const referrer = document.referrer || 'Direct Visit';

        // Get timestamp
        const timestamp = new Date().toISOString();

        // Combine all data into one object
        const userData = {
          ipAddress,
          location: `${locationData.city}, ${locationData.region}, ${locationData.country}`,
          userAgent,
          referrer,
          timestamp
          // Add more attributes as needed
        };
        console.log('User Data', userData);
        setUserData(userData);
        
        // database.ref('userVisits').push(userData);
        const userDataRef = ref(database, 'userVisits');
        push(userDataRef, userData);

      } catch (error) {
        console.error('Error fetching user data:', error);
      }
    };

    fetchUserData();
  }, []); // Empty dependency array ensures this effect runs only once after component mount

};

export default Analytics;
